import { graphql } from "relay-runtime"

export const chUpdatePatientSocialHistoryMutation = graphql`
  mutation chUpdatePatientSocialHistoryMutation($input: Ch_updatePatientSocialHistoryInput!) {
    updatePatientSocialHistory: ch_updatePatientSocialHistory(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      socialHistory {
        ...SocialHistoryFragment
      }
    }
  }
`
